<template>
  <v-card class="mb-2">
    <v-card-text>
      <h1 class="host-dashboard-title">My Events</h1>
      <!-- MOBILE -->
      <div class="hidden-md-and-up">
        <v-card raised v-for="event in getMyEvents" :key="event.uuid">
          <!-- <v-card-media :src="event.primary_image.image" height="150px"></v-card-media> -->
          <v-img
            :src="event.primary_image.image"
            aspect-ratio="1.7778"
          ></v-img>
          <v-card-text>
            {{ event.title }} <br>
            {{ eventDateTimeMobile(event) }} <br>
            <p v-if="event.location">{{getAddress(event.location)}}</p>
            <p>Attendees: {{event.attendees.length}}/{{event.max_attendees}}</p>
            <p>Guest Requests: {{ event.pending_attendees.length }}</p>
            <p v-if="event.cancelled" style="color: red;">
              Event cancelled
            </p>
            <p v-else-if="!event.approved" style="color: red;">
              Event not approved yet
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn class="info" block style="color:white!important" large :to="{ name: 'host_dashboard_event_details', params: { slug: event.slug }}">
              Manage Event
            </v-btn>
            <!-- <v-btn class="warning" block style="color:white!important" large :to="{ name: 'host_dashboard_event_details', params: { slug: event.slug }}">
              Live Page
            </v-btn> -->
            <v-btn class="success" block style="color:white!important" large :to="{ name: 'event', params: { slug: event.slug }}">
              View Event
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
      <!-- DESKTOP -->
      <div class="hidden-sm-and-down">
        <v-data-table
          :headers="headers"
          :items="getMyEvents"
          hide-actions
          class="elevation-1"
          item-key="title"
        >
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded" class="cursor-pointer">
              <td class="pa-2"><img :src="props.item.primary_image.image" height="50"></td>
              <td class="host-dashboard-tile-title">{{props.item.title}}</td>
              <td class="host-dashboard-tile-sub-title hidden-xs-only">{{ eventDateTime(props.item) }}</td>
              <td class="host-dashboard-tile-sub-title hidden-xs-only" v-if="props.item.location">{{getAddress(props.item.location)}}</td>
              <td class="host-dashboard-tile-sub-title">{{props.item.attendees.length}}/{{props.item.max_attendees}}</td>
              <td class="host-dashboard-tile-sub-title">{{ props.item.pending_attendees.length }}</td>
              <td v-if="props.item.cancelled" class="host-dashboard-tile-sub-title" style="color: red;">
                Event Cancelled
              </td>
              <td v-else-if="!props.item.approved" class="host-dashboard-tile-sub-title warning--text">
                Awaiting Approval
              </td>
              <td v-else-if="props.item.approved" class="host-dashboard-tile-sub-title warning--text">
                Approved
              </td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <v-card flat>
              <v-card-text>
                <v-btn class="info" style="color:white!important" large :to="{ name: 'host_dashboard_event_details', params: { slug: props.item.slug }}">
                  Manage Event
                </v-btn>
                <!-- <v-btn class="warning" style="color:white!important" large :to="{ name: 'host_dashboard_event_details', params: { slug: props.item.slug }}">
                  Live Event Page
                </v-btn> -->
                <v-btn class="success" style="color:white!important" large :to="{ name: 'event', params: { slug: props.item.slug }}">
                  Go to Event Page
                </v-btn>
              </v-card-text>
            </v-card>
          </template>
          <template slot="no-data">
            <v-alert :value="true" color="error" icon="warning">
              Sorry, nothing to display here :(
            </v-alert>
          </template>
        </v-data-table>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn class="btn-blue" @click="newEvent">New Event</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import {getAddressStringFromObject, get12hTimeString} from '~/utils/helper'
export default {
  name: 'host_dashboard_upcoming_events',
  data () {
    return {
      headers: [
        {
          text: 'Image',
          sortable: false,
          value: 'image'
        },
        { text: 'Title', sortable: false, value: 'title' },
        { text: 'Date & Time', sortable: false, value: 'date' },
        { text: 'Location', sortable: false, value: 'location' },
        { text: 'Attendees', sortable: false, value: 'attendees' },
        { text: 'Guest Requests', sortable: false, value: 'guest_requests' },
        { text: 'Status', sortable: false, value: 'status' }
      ]
    }
  },
  methods: {
    ...mapActions([
      'addEventResetState'
    ]),
    newEvent() {
			this.addEventResetState()
			this.$router.push('/host/add/event')
		},
    convertTime(time) {
			return get12hTimeString(time)
		},
    eventDateTime(event) {
			let date = moment(event.date).format('dddd MMMM Do')
			let timeStart = event.time_start
			let timeEnd = event.time_end
			return (
				date +
				' --- ' +
				this.convertTime(timeStart) +
				' - ' +
				this.convertTime(timeEnd)
			)
		},
    eventDateTimeMobile(event) {
			let date = moment(event.date).format('MMM Do')
			let timeStart = event.time_start
			let timeEnd = event.time_end
			return (
				date +
				' ' +
				this.convertTime(timeStart) +
				'-' +
				this.convertTime(timeEnd)
			)
		},
    getAddress(location) {
			return getAddressStringFromObject(location)
		}
  },
  computed: {
    ...mapGetters([
      'getMyEvents',
      'getHost',
			'userIsHost'
    ])
  }
}
</script>

<style>
.cursor-pointer:hover {
  cursor: pointer;
}
</style>
